import * as Sentry from '@sentry/react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createSentryReduxEnhancer(): any {
  return Sentry.createReduxEnhancer({
    actionTransformer: (action) => {
      if (action.type === 'device/setDevice') {
        return {
          ...action,
          payload: {
            ...action.payload,
            iphoneRegistrationToken: undefined,
            user: action.payload.user
              ? {
                  ...action.payload.user,
                  authorizationToken: undefined,
                }
              : undefined,
          },
        };
      }

      return action;
    },
    stateTransformer: (state) => {
      if (state == null) {
        return state;
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const hasNoDevice = (state as any).deviceState.device == null;
      if (hasNoDevice) {
        return {
          ...state,
        };
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const hasNoUser = (state as any).deviceState.device.user;

      return {
        ...state,
        deviceState: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ...(state as any).deviceState,
          device: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...(state as any).deviceState.device,
            user: hasNoUser
              ? undefined
              : {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ...(state as any).deviceState.device.user,
                  authorizationToken: undefined,
                },
            iphoneRegistrationToken: undefined,
          },
        },
      };
    },
  });
}
